import { type PropsWithChildren, createContext, useContext, useState } from 'react';

type HeaderContextType = {
  title: string | null;
  setTitle: (title: string | null) => void;
  exampleAIQuestions: string[];
  setExampleAIQuestions: (questions: string[]) => void;
};

const HeaderContext = createContext<HeaderContextType | undefined>(undefined);

export const useHeaderContext = () => {
  const context = useContext(HeaderContext);
  if (!context) {
    throw new Error('useHeaderContext must be used within a HeaderProvider');
  }
  return context;
};

export const HeaderProvider = ({ children }: PropsWithChildren) => {
  const [title, setTitle] = useState<string | null>(null);
  const [exampleAIQuestions, setExampleAIQuestions] = useState<string[]>([]);

  return (
    <HeaderContext.Provider value={{ title, setTitle, exampleAIQuestions, setExampleAIQuestions }}>
      {children}
    </HeaderContext.Provider>
  );
};
